<template>
  <div class="main-container">
    <header class="tabs-header">
      <button
        v-for="tab in tabs"
        :key="tab.id"
        class="tab-button"
        :class="{ active: activeTab === tab.componentName }"
        @click="activeTab = tab.componentName"
      >
        {{ tab.name }}
      </button>
    </header>
    <main class="content-area">
      <component :is="activeComponent"></component>
    </main>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import PottingTab from "@/views/tabs/PottingTab.vue";
import WeldingTab from "@/views/tabs/WeldingTab.vue";
import BindingTab from "@/views/tabs/BindingTab.vue";
import CheckStatus from "@/views/tabs/CheckStatus.vue";

const activeTab = ref("PottingTab");
const tabs = [
  { id: 1, name: "灌胶", componentName: "PottingTab", component: PottingTab },
  {
    id: 2,
    name: "超声波焊接",
    componentName: "WeldingTab",
    component: WeldingTab,
  },
  {
    id: 3,
    name: "标签绑定",
    componentName: "BindingTab",
    component: BindingTab,
  },
  {
    id: 4,
    name: "设备状态",
    componentName: "CheckStatus",
    component: CheckStatus,
  },
];
const activeComponent = computed(() => {
  const tab = tabs.find((t) => t.componentName === activeTab.value);
  return tab ? tab.component : null;
});
</script>

<style scoped>
/* 响应式优化：修改为绝对定位，占满屏幕并保留1rem边距 */
.main-container {
  position: absolute;
  top: 1rem;
  left: 1rem;
  right: 1rem;
  bottom: 1rem;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 1200px; /* 保留一个合理的最小宽度 */
  min-height: 600px; /* 保留一个合理的最小高度 */
  border: 1px solid #e4e7ed;
  border-radius: var(--border-radius-base);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background-color: #fff;
}
.tabs-header {
  display: flex;
  flex-shrink: 0;
  height: 3.2rem;
  width: 100%;
  background-color: #f5f7fa;
  border-bottom: 1px solid #e4e7ed;
}
.tab-button {
  padding: 0 1.25rem;
  font-size: 1rem;
  border: none;
  background-color: transparent;
  cursor: pointer;
  color: #909399;
  outline: none;
  transition: all 0.3s;
  flex: 1;
}
.tab-button.active {
  color: #409eff;
  font-weight: bold;
  border-bottom: 3px solid #409eff;
  background-color: #fff;
}
.tab-button:hover:not(.active) {
  color: #666;
}
.content-area {
  padding: 0.5rem;
  background-color: #fff;
  flex-grow: 1;
  overflow: auto;
  height: 100%; /* 确保内容区高度正确 */
}
</style>
